import React, { useState } from "react";
import { Calendar as CalendarIcon, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

/** Formats a Date as "Month DD, YYYY" (e.g., "March 12, 2024") */
function formatLongDate(d) {
  if (!d) return "";
  return d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
}

function parseLongDate(s) {
  if (!s) return undefined;
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? undefined : d;
}

export default function DatePickerField({ label, value, onChange, testId }) {
  const [open, setOpen] = useState(false);
  const selected = parseLongDate(value);

  return (
    <div>
      {label && (
        <label className="block text-[10px] uppercase tracking-[0.2em] text-[#001F3F] font-sans font-semibold mb-1.5">
          {label}
        </label>
      )}
      <div className="flex items-center gap-1">
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <button
              type="button"
              className="flex-1 px-3 py-2 bg-white border border-gray-200 text-sm font-sans text-left flex items-center justify-between focus:outline-none focus:border-[#2BA6A6]"
              data-testid={testId}
            >
              <span className={value ? "text-[#001F3F]" : "text-gray-400"}>
                {value || "Select date…"}
              </span>
              <CalendarIcon className="w-4 h-4 text-[#2BA6A6]" />
            </button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0 bg-white" align="start">
            <Calendar
              mode="single"
              selected={selected}
              onSelect={(d) => {
                onChange(d ? formatLongDate(d) : "");
                setOpen(false);
              }}
              initialFocus
            />
          </PopoverContent>
        </Popover>
        {value && (
          <button
            type="button"
            onClick={() => onChange("")}
            className="text-gray-400 hover:text-red-500 p-1"
            aria-label="Clear date"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
}
